import type { ClassDayResponse } from "@/openapi/generated";
import { getStudioClock, studioTodayDate } from "@/lib/utils/date/studio-clock";

const dayNames = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

function parseStartMinutes(startTime: string | null | undefined): number | null {
  if (!startTime) return null;
  const [hours, minutes] = startTime.split(":").map(Number);
  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null;
  return hours * 60 + minutes;
}

export function calculateNextClassDate(
  classDays: ClassDayResponse[] | undefined,
  now: Date = new Date(),
  timeZone?: string | null,
): number | null {
  if (!classDays || classDays.length === 0) return null;

  const clock = getStudioClock(now, timeZone);
  const today = studioTodayDate(clock);
  let soonestMs: number | null = null;

  for (const classDay of classDays) {
    const startMinutes = parseStartMinutes(classDay.startTime);
    if (startMinutes == null) continue;
    const targetDay = dayNames.indexOf(classDay.day ?? "");
    if (targetDay === -1) continue;

    let daysUntilNext = targetDay - clock.weekdayIndex;
    if (daysUntilNext < 0) daysUntilNext += 7;
    if (
      daysUntilNext === 0 &&
      clock.minutesFromMidnight > startMinutes
    ) {
      daysUntilNext = 7;
    }

    const nextClassDate = new Date(today);
    nextClassDate.setDate(today.getDate() + daysUntilNext);
    nextClassDate.setHours(0, 0, 0, 0);
    const ms = nextClassDate.getTime();
    if (soonestMs == null || ms < soonestMs) {
      soonestMs = ms;
    }
  }

  return soonestMs;
}
